import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from '../../../utils'
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from "react-i18next";

export const Jelly = ({topLabel, carName, carModel, carPrice, carFeatures, carImg, carImgHover, jellieHaveIcons, icon1, icon2, icon3, btnLabel, onClick, isComingSoon, ...props }) => {
    const { t, i18n } = useTranslation(['vehicles', 'general']);    
    const displayFeatures = carFeatures.map((feature, key) => {

		let iconType = feature.icon_type;
        iconType = iconType==='seat'? 'seats' : iconType;
		iconType = iconType==='awd'? 'drivetrain' : iconType;
		feature.icon_type = iconType; //Pass it back into the array.

        return (
            <div className="mz-icon-text " key={key}>
                <div className="mz-icon-text-icon">
                    <i className={"mz-svg mz-svg-feature_"+feature.icon_type}/>
                </div>
                <div className="mz-icon-text-text">{ReactHtmlParser(feature.content)}</div>
            </div>
        )
    })

    return (
        <div
            className={ isComingSoon ? 'mz-jelly disabled' :'mz-jelly'}
            {...props}
            onClick={() => onClick()}
        >
            {topLabel ? <span className="mz-jelly-top paragraph">{topLabel}</span> : <span className="mz-jelly-top">&nbsp;</span>}
            <div className={ isComingSoon ? 'mz-jelly-container disabled' :'mz-jelly-container'} >
                <div className="mz-image mz-jelly-image">
                    <img className="lazy" src={carImg} alt={'Car image'}/>
                </div>
                <div className="mz-image mz-jelly-image--hover">
                    <img className="lazy" src={carImgHover} alt={'Car image angled'}/>

                </div>
            </div>
            <div className={ isComingSoon ? 'mz-jelly-content disabled' :'mz-jelly-content'}>
                <h5>{ReactHtmlParser(carName)}</h5>
                
                <div>{carModel} { !isComingSoon && carPrice > 0 ? `-  ${t("jelly_starting_at")}  ${formatPrice(carPrice)} `:''} { isComingSoon ? '' : <sup>1</sup>}</div>
            </div>
            <div className="mz-jelly-iconslist">{displayFeatures}</div>
        </div>
    );
};

Jelly.propTypes = {
    jellieHaveIcons: PropTypes.bool,
    icon1: PropTypes.bool,
    icon2: PropTypes.bool,
    icon3: PropTypes.bool,
    topLabel: PropTypes.string,
    carName: PropTypes.string,
    carModel: PropTypes.string,
    carFeatures: PropTypes.array,
    // carPrice: PropTypes.string,
    carImg: PropTypes.string,
    carImgHover: PropTypes.string,
    btnLabel: PropTypes.string,
    onClick: PropTypes.func,
}

Jelly.defaultProps = {
    jellieHaveIcons: true,
    icon1: true,
    icon2: true,
    icon3: true,
    topLabel: '',
    carName: '',
    carModel: '',
    carPrice: '',
    carFeatures: [
        {
            "content": "5",
            "icon_type": "seats"
        },
        {
            "content": "Available AWD",
            "icon_type": "awd"
        },
        {
            "content": "Available Turbo Engine",
            "icon_type": "turbo"
        }
    ],
    carImg: '',
    carImgHover: '',
    btnLabel: 'BUILD YOURS',
    onClick: undefined,
}

export default Jelly;